
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Building } from "lucide-react";
import AddRoomDialog from "./AddRoomDialog";
import RoomCard from "./RoomCard";
import { Room } from "@/hooks/useRooms";

interface RoomsManagementProps {
  providerId: string;
  rooms: Room[];
  roomsLoading: boolean;
  servicesCount: (roomId: string) => number;
  onRoomAdded: () => void;
  onServicesUpdated: () => void;
}

const RoomsManagement = ({ 
  providerId, 
  rooms, 
  roomsLoading, 
  servicesCount, 
  onRoomAdded, 
  onServicesUpdated 
}: RoomsManagementProps) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
          <CardTitle className="flex items-center space-x-2">
            <Building className="h-5 w-5" />
            <span>Rooms</span>
          </CardTitle>
          <AddRoomDialog providerId={providerId} onRoomAdded={onRoomAdded} />
        </div>
      </CardHeader>
      
      <CardContent>
        {roomsLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-64 bg-gray-200 rounded animate-pulse"></div>
            ))}
          </div>
        ) : rooms && rooms.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {rooms.map((room) => (
              <RoomCard 
                key={room.id} 
                room={room} 
                servicesCount={servicesCount(room.id)}
                onServicesUpdated={onServicesUpdated}
                showManagementButtons={true}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            <Building className="h-12 w-12 mx-auto mb-4 text-gray-300" />
            <p>No rooms created yet</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default RoomsManagement;
